import FormWrapper from 'components/Form/FormWrapper'
import styled from 'styled-components'
import HistoryTable from './components/HistoryTable'
import FilterForm from './components/FilterForm'
import { useCallback, useEffect, useState } from 'react'
import { productService } from 'services'
import { useLocation, useHistory } from 'react-router-dom'
import * as qs from 'query-string'

const WrapperPage = styled.div`
  min-height: 77vh;
  width: 100%;
  padding: 0 20px 40px;
`

const Page = () => {
  const location = useLocation()
  const history = useHistory()

  const [dataList, setDataList] = useState<any>()
  const [loadingList, setLoadingList] = useState<boolean>(true)
  const [params, setParams] = useState<any>(() => {
    const query = qs.parse(location.search)
    return {
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      title: query.title || undefined,
    }
  })
  useEffect(() => {
    const query = qs.parse(location.search)
    setParams({
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      title: query.title || undefined,
    })
  }, [])
  useEffect(() => {
    if (params) {
      const queryString = qs.stringify(params)
      history.push({
        pathname: history.location.pathname,
        search: queryString ? `?${queryString}` : '',
      })
    }
  }, [history, params])

  const getProductList = useCallback(() => {
    if (params) {
      setLoadingList(true)
      productService.getList(params, (data) => {
        setDataList(data)
        setLoadingList(false)
      })
    }
  }, [params])


  useEffect(() => {
    getProductList()
  }, [getProductList])

  return (
    <WrapperPage>
      <p className='title-page'>Quản lý sản phẩm</p>

      <FormWrapper>
        {<FilterForm
          params={params}
          setParams={setParams}
          setLoadingList={setLoadingList}
          loadingList={loadingList}
        />}

        <HistoryTable
          dataList={dataList}
          setParams={setParams}
        />
      </FormWrapper>
    </WrapperPage>
  )
}

export default Page
